export default "__VITE_ASSET__e67665b8__"